import { RootState } from "redux/schemas";
import { MentoringProgramEnrollment } from "redux/schemas/models/mentoring-program-enrollments";
import { createSelector } from "reselect";

export type MentorPrevNext = {
  currentMentorId: number | null;
  previousMentorId: number | null;
  nextMentorId: number | null;
};

export const selectMentorsList = createSelector(
  (state: RootState) => state.models.mentoringProgramParticipantDrivenMentors,
  (state, ids: number[]) => ids,
  (mentoringProgramParticipantDrivenMentors: Record<number, MentoringProgramEnrollment>, ids: number[]) => ids.map((id) => mentoringProgramParticipantDrivenMentors[id]),
);

export const getMentorResultById = (mentorId: number) => (state: RootState) => (
  state.models.mentoringProgramParticipantDrivenMentors?.[mentorId]
);

export const selectMentorsFilters = (state: RootState) => {
  const { mentorsFilters, mentorsFiltersKeys } = state.app.mentoringProgram.participantDriven;
  return (mentorsFiltersKeys || []).map((id) => mentorsFilters[id]);
};

export const selectMentorsResultsCount = (state: RootState) => (
  state.app.mentoringProgram.participantDriven.resultsCount || 0
);

// Find a mentor modal search & filters
export const selectLastMentorsSearchTerm = (state: RootState) => (
  state.app.mentoringProgram.participantDriven.findMentorSource?.searchTerm || ''
);

export const selectLastMentorsFilters = (state: RootState) => (
  state.app.mentoringProgram.participantDriven.findMentorSource?.filters || []
);

export const selectFindAMentorPrevNext = (mentorId: number) => (state: RootState) => {
  const mentorIds = state.app.mentoringProgram.participantDriven.findMentorSource?.resultKeys || [];
  const mentorIndex = mentorIds.indexOf(Number(mentorId));
  return {
    currentMentorId: mentorIds[mentorIndex] ?? null,
    previousMentorId: mentorIndex > 0 ? mentorIds[mentorIndex - 1] : null,
    nextMentorId: mentorIndex >= 0 && mentorIndex < mentorIds.length - 1 ? mentorIds[mentorIndex + 1] : null,
  };
};

export const selectShouldLoadMoreMentors = (mentorId: number) => (state: RootState) => {
  const findMentorSource = state.app.mentoringProgram.participantDriven.findMentorSource;
  const resultKeys = findMentorSource?.resultKeys || [];
  const totalCount = state.app.mentoringProgram.participantDriven.resultsCount || 0;
  const lastPage = findMentorSource?.lastPage || 0;
  const searchTerm = findMentorSource?.searchTerm || '';
  const filters = findMentorSource?.filters || {};
  const isLoading = findMentorSource?.isLoading || false;

  const currentIndex = resultKeys.indexOf(Number(mentorId));
  const loadedCount = resultKeys.length;

  // Check if we're within 3 items of the end and haven't loaded all results yet
  const shouldLoad = currentIndex >= loadedCount - 3 && loadedCount < totalCount && !isLoading;

  return {
    shouldLoad,
    searchParams: shouldLoad ? {
      searchTerm,
      filters: Object.entries(filters).map(([question_id, answers]) => ({
        question_id: Number(question_id),
        answers: answers as string[],
      })),
      page: lastPage + 1,
    } : null,
  };
};
